const nodes = [
  { label: "AI APP", className: "node--model" },
  { label: "AIoT", className: "node--agent" },
  { label: "CLOUD", className: "node--app" },
  { label: "SENSOR", className: "node--cloud" },
  { label: "EDGE AI", className: "node--edge" },
  { label: "DEVICE", className: "node--device" },
];

export function SystemVisual() {
  const { l } = useI18n();
  return (
    <div
      className="system-visual"
      role="img"
      aria-label={l(
        "AI 应用、云边系统与智能硬件协同的完整技术链",
        "A connected product system spanning AI applications, cloud, edge, and smart hardware",
      )}
    >
      <div className="system-visual__grid" aria-hidden="true" />
      <div
        className="system-visual__orbit system-visual__orbit--one"
        aria-hidden="true"
      />
      <div
        className="system-visual__orbit system-visual__orbit--two"
        aria-hidden="true"
      />
      <svg
        className="system-visual__links"
        viewBox="0 0 640 520"
        aria-hidden="true"
      >
        <path d="M90 94 320 190 518 100M320 190 156 310M320 190l168 132M156 310l150 126M488 322 306 436" />
      </svg>
      {nodes.map((node, index) => (
        <div key={node.label} className={`system-node ${node.className}`}>
          <span>{String(index + 1).padStart(2, "0")}</span>
          <strong>{node.label}</strong>
          <i aria-hidden="true" />
        </div>
      ))}
      <div className="system-visual__status">
        <i /> {l("系统已连接", "SYSTEM CONNECTED")}
      </div>
    </div>
  );
}

import { useI18n } from "../i18n";
